import Client from './client';
import { sessionService } from 'redux-react-session';
import { Auth } from 'aws-amplify';
import { Logger } from '../_clean-code/utils/logger';
import { SELECTED_COMPANY_ID } from '../constants';

let endpoint = import.meta.env.VITE_APP_ENDPOINT;
if (endpoint && !endpoint.startsWith('http')) {
  endpoint = `https://${endpoint}`;
}
const baseUrl = endpoint || 'https://dev-api.pulsarml.com';

const api = Client.create(baseUrl);
api.addErrorInterceptor((error) => {
  if (error.response?.status === 401) {
    try {
      Auth.currentAuthenticatedUser({ bypassCache: true });
    } catch (error) {
      localStorage.clear();
      window.location.href = '/login';
      Logger.info(
        'legacy-client::api::response: 401 error, clearing localStorage and redirecting to login'
      );
      // TODO: remove this as redux-react-session doesn't seem to be used anymore
      sessionService.deleteUser();
      sessionService.deleteSession();
    }
  } else if (error.response && error.config?.url) {
    Logger.error(
      `legacy-client::api::response: ${error.message} calling ${error.config.url}`,
      error
    );
  }
  if (
    error.response?.status === 403 &&
    error.response?.data.message === 'FORBIDDEN: Invalid Company'
  ) {
    localStorage.removeItem(SELECTED_COMPANY_ID); // this resets the company selection
    Logger.info('Company not found, clearing localStorage company selection');
  }

  return Promise.reject(error);
});

export const BASE_URL = baseUrl;

window.app = {
  isApiLocal: false,
  setApiLocal: () => (window.app.isApiLocal = true),
  setApiRemote: () => (window.app.isApiLocal = false)
};

export default api;
